import React from 'react';
import { Provider } from 'react-redux';
import { createIntl, IntlProvider } from 'react-intl';
import messages_en from './translations/en.json';
import messages_en_GB from './translations/en_GB.json';
import { getLocale } from './utils/useful_functions';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './query-client';

const messages = {
  en: messages_en,
  'en-GB': messages_en_GB,
};

export const DEFAULT_INTL = createIntl({
  locale: getLocale(),
  messages,
});

const ProviderWrapper = (props: any) => {
  const locale = getLocale();

  return (
    <Provider store={props.store}>
      <QueryClientProvider client={queryClient}>
        <IntlProvider locale={locale} messages={messages[locale]}>
          {props.children}
        </IntlProvider>
      </QueryClientProvider>
    </Provider>
  );
};

export default ProviderWrapper;
